<template>
  <component
    :is="tag"
    class="font-bold text-primary"
    :class="[
      size ? size : 'text-2xl lg:text-4xl',
      {
        'border-l-4 border-primary-blue pl-2': line,
        'mb-6 lg:mb-10': !hideSpace,
      },
    ]">
    <slot />
  </component>
</template>

<script setup lang="ts">
  type Props = {
    tag?: string;
    line?: boolean;
    size?: string;
    hideSpace?: boolean;
  };
  withDefaults(defineProps<Props>(), {
    tag: 'h5',
  });
</script>
